const config = {
  name: "honkdemo",
  features: {
    accessCodes: true,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: true, // Display "Redemptions left" on promo code card
    mandatoryFields: true,
    userPhoneNumber: true, // we can QA this on honkdemo
    showAdaSupport: false,
    userName: true,
    userPostalCode: true
  },
  parkingSession: {
    // The same day, just before 6am
    cancelDaysBefore: 0,
    cancelTime: "06:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 6 am
    startOffsetHrs: 6,
    // Start date offset from today (0 = today)
    startOffsetDate: 0,
    // End date offset from start time
    endOffsetDate: 120
  }
}
export default config
